import { injectable } from 'inversify';
import { action, observable } from 'mobx';

import UserAPI from '~gateways/user-api';

@injectable()
class SmartBrowserStore {
  @observable savedPreferences: {
    smartBrowsingActive: boolean;
    smartBrowsingDeactivationWarning: boolean;
  } | null = null;

  @action public initialise = async () => this.getUserPreferences();

  @action public getUserPreferences = async () => {
    const response = await UserAPI.getUserPreferences();
    if (response?.success) {
      this.savedPreferences = response.preferences.smartBrowsing;
      return response.preferences.smartBrowsing;
    }

    return null;
  };

  @action public postLogin = async () => {
    const response = await this.getUserPreferences();
    if (response?.smartBrowsingDeactivationWarning) {
      await this.setUserSmartBrowsing(true, true);
      return;
    }
    await this.setUserSmartBrowsing(true, false);
  };

  @action public setUserSmartBrowsing = async (
    active: boolean,
    warning: boolean
  ) => {
    const response = await UserAPI.setUserSmartBrowsing(active, warning);
    if (response) {
      this.savedPreferences = {
        smartBrowsingActive: response.smartBrowsingActive,
        smartBrowsingDeactivationWarning:
          response.smartBrowsingDeactivationWarning,
      };
    }
    return response;
  };
}

export default SmartBrowserStore;
